<template>
    <div class="editor">
        <editor-menu-bar :editor="editor" v-slot="{ commands }">
            <div class="menubar">
                <button type="button" class="menubar__button" v-on:click="commands.bold()"><i class="fas fa-bold" /></button>
                <button type="button" class="menubar__button" v-on:click="commands.italic"><i class="fas fa-italic" /></button>
                <button type="button" class="menubar__button" v-on:click="commands.strike"><i class="fas fa-strikethrough" /></button>
                <button type="button" class="menubar__button" v-on:click="commands.underline"><i class="fas fa-underline" /></button>
                <button type="button" class="menubar__button" v-on:click="commands.paragraph"><i class="fas fa-paragraph" /></button>
                <button type="button" class="menubar__button" v-on:click="commands.heading({ level: 1 })"><i class="fas fa-h1" /></button>
                <button type="button" class="menubar__button" v-on:click="commands.heading({ level: 2 })"><i class="fas fa-h2" /></button>
                <button type="button" class="menubar__button" v-on:click="commands.heading({ level: 3 })"><i class="fas fa-h3" /></button>
                <button type="button" class="menubar__button" v-on:click="commands.bullet_list"><i class="fas fa-list-ul" /></button>
                <button type="button" class="menubar__button" v-on:click="commands.ordered_list"><i class="fas fa-list-ol" /></button>
                <button type="button" class="menubar__button" v-on:click="showImagePrompt(commands.image)"><i class="fas fa-image" /></button>
                <button type="button" class="menubar__button" v-on:click="commands.undo"><i class="fas fa-undo" /></button>
                <button type="button" class="menubar__button" v-on:click="commands.redo"><i class="fas fa-redo" /></button>
            </div>
        </editor-menu-bar>
        <editor-content height="250px" class="editor_content" :editor="editor" />
    </div>
</template>

<script>
    import {Editor, EditorContent, EditorMenuBar} from 'tiptap'
    import {
        Blockquote,
        CodeBlock,
        HardBreak,
        Heading,
        HorizontalRule,
        OrderedList,
        BulletList,
        ListItem,
        TodoItem,
        TodoList,
        Bold,
        Italic,
        Image,
        Link,
        Strike,
        Underline,
        History,
    } from 'tiptap-extensions'

    export default {
        getEditor() {
          return this.editor;
        },
        getHTML() {
            return this.html;
        },
        components: {
            EditorContent,
            EditorMenuBar
        },
        data() {
            return {
                editor: new Editor({
                    extensions: [
                        new Blockquote(),
                        new BulletList(),
                        new CodeBlock(),
                        new HardBreak(),
                        new Heading({levels: [1, 2, 3]}),
                        new HorizontalRule(),
                        new ListItem(),
                        new OrderedList(),
                        new TodoItem(),
                        new TodoList(),
                        new Link(),
                        new Bold(),
                        new Italic(),
                        new Strike(),
                        new Underline(),
                        new History(),
                        new Image(),
                    ],
                    content: `hello <b>world!</b>`,
                    onUpdate: ({ getHTML }) => {
                        this.html = getHTML();
                        console.log(this.html);
                    },
                }),
                html:'',
            }
        },
        beforeDestroy() {
            this.editor.destroy()
        },
        methods: {
            showImagePrompt(command) {
                const src = prompt('Enter the url of your image here')
                if (src !== null) {
                    command({ src })
                }
            }
        },
    }
</script>

<style lang="less" scoped>
    .editor {
        border: 1px solid rgba(0,0,0,0.2);
        border-radius:4px;

        .menubar {
            padding: 2px;
            background-color: rgba(0,0,0,.05);
            border-bottom: 1px solid rgba(0,0,0,0.1);

            button {
                background-color: transparent;
                border: none;
                outline: none;
                margin: 2px;
                height: 28px;
                width: 28px;
                cursor: pointer;
                border-radius: 3px;
                color:#666;
                transition: background-color 200ms linear;

                &:hover {
                    color:#333;
                    background-color: rgba(0,0,0,0.1);
                }
            }
        }

        .editor__content {
            min-height: 200px;
            margin: 0;
            padding: 20px;
            outline: none;
        }
    }
    .ProseMirror [contenteditable="true"] {
        white-space: pre-wrap;
        color:red;
    }
</style>